import styled from 'styled-components'

export const GlobalSearchModalLayoutStyled = styled.div`
  display: grid;
  grid-template-areas:
    'header close'
    'content content';
  grid-template-columns: 1fr auto;
`

export const GlobalSearchModalHeaderAreaStyled = styled.div`
  grid-area: header;
`

export const GlobalSearchModalContentAreaStyled = styled.div`
  grid-area: content;
`

export const GlobalSearchModalCloseAreaStyled = styled.div`
  grid-area: close;
  align-self: start;
  padding: ${(props) => props.theme.space.small}
    ${(props) => props.theme.typography.pxToRem(8)} 0;
`
